module.exports = __webpack_public_path__ + "static/media/vector.80b8902a.svg";